import { styled } from '@/stitches.config';
import { Box, TableCell, TableRow } from '@base-app';

export const StyledTableHeadRow = styled(TableRow, {
  color: '$darkBlue300',
  fontSize: '$4',
  lineHeight: '$6',
  fontWeight: '$bold',
  backgroundColor: '$white',
  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        pointerEvents: 'none',
      },
    },
  },
});

export const StyledTableHeadCell = styled(TableCell, {
  cursor: 'pointer',
});

export const StyledTableHeadOrderIdCell = styled(StyledTableHeadCell, {
  cursor: 'auto',
  width: '30%',
});

export const StyledTableHeadDateReceivedCell = styled(StyledTableHeadCell, {
  width: '30%',
});

const StyledCaret = styled(Box, {
  display: 'inline-block',
  margin: '$1 $1',
  verticalAlign: 'center',
  width: '0',
  height: '0',
});

export const StyledCaretUp = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderBottom: '$borderWidths$5 solid $colors$black',
});

export const StyledCaretDown = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderTop: '$borderWidths$5 solid $colors$black',
});

export const StyledTableBodyCell = styled(TableCell, {
  border: '$0',
});

export const StyledTableBodyRow = styled(TableRow, {
  color: '$charcoal300',
});

export const StyledNotResultsRowText = styled(TableRow, {
  'tbody &:hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledNotResultsCellText = styled(TableCell, {
  fontWeight: '$medium',
  fontSize: '$5',
  lineHeight: '$6',
  textAlign: 'center',
  margin: '55px auto',
});

export const PaginationContainerStyled = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  mb: '$12',
  mt: '$8',
  justifyContent: 'center',

  '@sm': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const StyledError = styled(Box, {
  color: '$error',
});

export const StyledViewReasonLink = styled('span', {
  color: '$blue300',
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:hover': {
    color: '$blue400',
  },
});
